<template>
  <div class="addLocationGroup">
    <div>
      <v-btn
        :disabled="!hasPermission"
        :loading="mapLoading"
        @click="modalOpen"
        class="pr-0"
        small
        color="primary"
      >
        <v-icon>add</v-icon><span>追加</span>
        <v-menu
          :close-on-content-click="true"
          :offset-y="true"
          nudge-left="66"
          bottom
          right
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              @click="$event.stopPropagation()"
              icon
              class="mr-0"
              ><v-icon>mdi-menu-down</v-icon></v-btn
            >
          </template>

          <v-card>
            <BulkAddMenuList
              :owner-profile-id="ownerProfileId"
              :has-permission="hasPermission"
              :geocoder="geocoder"
              @onClickMenu="openBulkAddModal"
            />
          </v-card>
        </v-menu>
      </v-btn>
    </div>
    <!-- 以下モーダル -->
    <!-- 地点グループ追加モーダル -->
    <AppModalEdit
      @clickExec="save"
      @cancel="groupAddModalClose"
      :value="isOpenGroupAddModal"
      title="グループ登録"
      exec-button-text="登録する"
      width="50%"
      min-height="100px"
    >
      <v-form ref="form" @submit.prevent>
        <v-text-field
          v-if="isOpenGroupAddModal"
          v-model="newLocationGroupName"
          :rules="[rules.required]"
          @keypress.enter="save"
          autofocus
          hint="新規グループ名を入力してください"
        />
      </v-form>
    </AppModalEdit>
    <!--地点バルク追加モーダル -->
    <LocationGroupModal
      v-if="isOpenGroupBulkAddModal"
      v-model="isOpenGroupBulkAddModal"
      :owner-profile-id="ownerProfileId"
    />
    <!-- 地点グループバルク・地点バルク追加モーダル -->
    <LocationGroupAndLocationModal
      v-if="isOpenGroupAndLocationBulkAddModal"
      v-model="isOpenGroupAndLocationBulkAddModal"
      :owner-profile-id="ownerProfileId"
      :geocoder="geocoder"
      @save="getLocationGroups"
    />
  </div>
</template>

<script>
import { actions, getters } from '@/vuex/modules/pointGroupOperation/constants'
import {
  actions as snackbarActions,
  snackbarType,
} from '@/vuex/modules/ui/snackbar/constants'
import LocationGroupOperation from '@/api/PointGroup/LocationGroupOperation/LocationGroupOperation'
import RouteHelper from '@/mixins/RouteHelper'
import BulkAddMenuList from '@/components/Advertiser/Operation/PointGroup/PointGroupOperation/PointGroup/BulkAddMenuList'
import { locationGroupType as LocationGroupType } from './constants'
import LocationGroupModal from '@/components/Advertiser/Operation/PointGroup/PointGroupOperation/PointGroup/LocationGroupModalBulkAdd'
import LocationGroupAndLocationModal from '@/components/Advertiser/Operation/PointGroup/PointGroupOperation/PointGroup/LocationGroupAndLocationModalBulkAdd'

export default {
  name: 'AddLocationGroup',
  components: {
    BulkAddMenuList,
    LocationGroupAndLocationModal,
    LocationGroupModal,
  },
  mixins: [RouteHelper],
  props: {
    locationGroupType: {
      type: String,
      default: LocationGroupType.CUSTOM_LOCATION,
    },
    hasPermission: {
      type: Boolean,
      default: false,
    },
    geocoder: {
      type: Function,
      required: true,
    },
    ownerProfileId: {
      type: Number,
      required: true,
    },
  },
  data: () => ({
    isOpenGroupAddModal: false,
    newLocationGroupName: '',
    loading: false,
    // 地点バルク追加モーダル
    isOpenGroupBulkAddModal: false,
    // 地点グループ・地点バルク追加モーダル
    isOpenGroupAndLocationBulkAddModal: false,
  }),
  computed: {
    mapLoading() {
      // 地点グループが1つも無い時はマップがロードされないので false
      if (this.groupList.length === 0) return false
      return !this.$store.getters[getters.mapLoaded]
    },
    groupList() {
      return this.$store.getters[getters.groupList]
    },
    hasUpdates() {
      return this.$store.getters[getters.targetGroupHasUpdates]
    },
    rules() {
      return LocationGroupOperation.validations
    },
  },
  methods: {
    async modalOpen() {
      if (this.hasUpdates) {
        const result = await this.$confirm(
          '追加・編集が破棄されますがよろしいですか？',
        )
        if (result) {
          this.$store.dispatch(actions.CLEAR_TARGET_GROUP)
        } else {
          return
        }
      }
      this.isOpenGroupAddModal = true
    },
    async save() {
      if (!this.$refs.form.validate()) {
        return false
      }
      this.loading = true
      const ownerProfileId = this.$route.params.ownerProfileId
      const accessibleType = this.underAdminPage ? 'private' : 'public'
      try {
        const {
          item: newGroup,
        } = await LocationGroupOperation.addLocationGroup({
          ownerProfileId,
          locationGroupType: this.locationGroupType,
          name: this.newLocationGroupName,
          accessibleType,
        })
        await this.$store.dispatch(actions.GET_GROUP_LIST, { ownerProfileId })
        this.groupAddModalClose()
        this.loading = false
        this.$store.dispatch(actions.SET_TARGET_GROUP, {
          groupData: newGroup,
        })

        this.$store.dispatch(snackbarActions.SHOW_SNACKBAR, {
          type: snackbarType.SUCCESS,
          message: '保存完了しました',
        })
      } catch (e) {
        this.loading = false
        const error = new Error('保存に失敗しました。')
        throw error
      }
    },
    groupAddModalClose() {
      this.newLocationGroupName = ''
      this.isOpenGroupAddModal = false
    },
    openBulkAddModal(menuType) {
      if (menuType === 'group') {
        this.isOpenGroupBulkAddModal = true
      }
      if (menuType === 'groupAndLocation') {
        this.isOpenGroupAndLocationBulkAddModal = true
      }
    },
    async getLocationGroups() {
      await this.$store.dispatch(actions.GET_GROUP_LIST, {
        ownerProfileId: this.ownerProfileId,
      })
    },
  },
}
</script>
